import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { HomePage } from './pages/HomePage';
import { AdCampaignsPage } from './pages/AdCampaignsPage';
import { AutomationsPage } from './pages/AutomationsPage';
import { CustomAutomationsPage } from './pages/CustomAutomationsPage';
import { WebDesignSeoPage } from './pages/WebDesignSeoPage';
import { PricingPage } from './pages/PricingPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';
import { RobotsTxt } from './pages/RobotsTxt';
import { SitemapXml } from './pages/SitemapXml';
import { CaseStudiesPage } from './pages/CaseStudiesPage';
import { TfpLandscapingPage } from './pages/CaseStudies/TfpLandscapingPage';
import { FinishCoatPaintingPage } from './pages/CaseStudies/FinishCoatPaintingPage';
import { GbpSetupPage } from './pages/GbpSetupPage';
import { GmailSignatureGeneratorPage } from './pages/tools/GmailSignatureGeneratorPage';
import { CrmBusinessToolsPage } from './pages/CrmBusinessToolsPage';
import { ReputationManagementPage } from './pages/ReputationManagementPage';
import { BlogPage } from './pages/BlogPage';
import { HowToChooseMarketingAgency } from './pages/blog/HowToChooseMarketingAgency';
import { WhyResponseTimeMakesOrBreaksYourYelpAds } from './pages/blog/WhyResponseTimeMakesOrBreaksYourYelpAds';
import { FasterYelpRepliesMoreLandscapingEstimates } from './pages/blog/FasterYelpRepliesMoreLandscapingEstimates';
import { AiReceptionistVsHumanReceptionistCost } from './pages/blog/AiReceptionistVsHumanReceptionistCost';
function SiteLayout() {
  return <div className="flex flex-col min-h-screen bg-viridia-black font-sans text-white" data-id="element-0" data-mp="stuclog6yl6w">
      <Navbar data-id="element-1" data-mp="35yp0k2nrm1g" />
      <noscript data-id="element-2" data-mp="35gkz19r83iz">
        <div style={{
        padding: '2rem',
        maxWidth: '800px',
        margin: '0 auto'
      }} data-id="element-3" data-mp="356wxj89s6fx">
          <h1 data-id="element-4" data-mp="d4nv7fl6zi1v">
            Viridia Analytics - Phoenix Marketing Agency for Local Service
            Businesses
          </h1>
          <p data-id="element-5" data-mp="85bd1859mz5m">
            We help local service businesses stop missing leads, respond
            instantly, and book more jobs. Real systems, real results from real
            Phoenix-area clients.
          </p>
          <h2 data-id="element-6" data-mp="3bnmgpliglb9e">Our Services</h2>
          <ul data-id="element-7" data-mp="3bk70uggyny6x">
            <li data-id="element-8" data-mp="3qb7j1d7if6g9">
              <a href="/ai-lead-conversion" data-id="element-9" data-mp="3qaxuzv60z9d7">
                AI Lead Conversion - Follow-Up, AI Receptionist, Lead Nurturing
              </a>
            </li>
            <li data-id="element-10" data-mp="3lj67jti61jra">
              <a href="/custom-automations" data-id="element-11" data-mp="3limv2sbabnkn">
                Custom Automations - Tailored Workflows, API Integrations
              </a>
            </li>
            <li data-id="element-12" data-mp="2sv0orcaoa4u3">
              <a href="/crm-business-tools" data-id="element-13" data-mp="2svjvrxysb8tc">
                CRM &amp; Business Tools - Centralized Hub, Invoicing, Pipeline
              </a>
            </li>
            <li data-id="element-14" data-mp="1d4rfiyyvhtf9">
              <a href="/reputation-management" data-id="element-15" data-mp="1d59kcjzlpfys">
                Reputation Management - Automated Reviews, Trust Building
              </a>
            </li>
            <li data-id="element-16" data-mp="13eoecbhll95u">
              <a href="/ad-campaigns" data-id="element-17" data-mp="13e56jnlnw15j">
                Ad Campaign Management - Google Ads, Meta Ads, and local lead
                platforms
              </a>
            </li>
            <li data-id="element-18" data-mp="1w3c1kclwq8m1">
              <a href="/web-design-seo" data-id="element-19" data-mp="1w3vmm26utd4a">Web Design &amp; Local SEO</a>
            </li>
          </ul>
          <h2 data-id="element-20" data-mp="1i442djpqv0hu">Contact Us</h2>
          <p data-id="element-21" data-mp="1i2syzl07nur9">
            Phone: <a href="tel:6233000708" data-id="element-22" data-mp="1i3b4l88rjlbu">(623) 300-0708</a>
          </p>
          <p data-id="element-23" data-mp="1m44sw2q4b259">
            Email:{' '}
            <a href="mailto:info@viridiaanalytics.com" data-id="element-24" data-mp="1m791rdej2m29">
              info@viridiaanalytics.com
            </a>
          </p>
          <p data-id="element-25" data-mp="apr7d4iu6yse">Location: Phoenix, AZ - Serving Local Businesses</p>
          <h2 data-id="element-26" data-mp="arbyek5xzzli">Quick Links</h2>
          <ul data-id="element-27" data-mp="qx5j265z12e6">
            <li data-id="element-28" data-mp="qxnnvr6p8oxp">
              <a href="/about" data-id="element-29" data-mp="qy72oz11yx7i">About Us</a>
            </li>
            <li data-id="element-30" data-mp="m6fdosxjozjh">
              <a href="/case-studies" data-id="element-31" data-mp="m5x4ywtp4suo">Case Studies</a>
            </li>
            <li data-id="element-32" data-mp="m4m16x093l3k">
              <a href="/pricing" data-id="element-33" data-mp="h72oi1j7bgdq">Pricing</a>
            </li>
            <li data-id="element-34" data-mp="h7lvin7bckcz">
              <a href="/contact" data-id="element-35" data-mp="h4zocooc46va">Book a Free Strategy Call</a>
            </li>
            <li data-id="element-36" data-mp="ca2jzv202loq">
              <a href="/privacy" data-id="element-37" data-mp="c6enqo567l6b">Privacy Policy</a>
            </li>
            <li data-id="element-38" data-mp="19vhqnnh8i47n">
              <a href="/terms" data-id="element-39" data-mp="19v88un6cf3d1">Terms of Service</a>
            </li>
          </ul>
        </div>
      </noscript>
      <main role="main" className="flex-grow" data-id="element-40" data-mp="14v3t4zd9ecnv">
        <Routes data-id="element-41" data-mp="zx2848w9w39r">
          <Route path="/" element={<HomePage data-id="element-43" data-mp="zzwvo9al247e" />} data-id="element-42" data-mp="zwiuv5hki322" />
          <Route path="/services" element={<Navigate to="/ai-lead-conversion" replace data-id="element-45" data-mp="vvp1vxp9py2b" />} data-id="element-44" data-mp="vwiehfawrhsd" />
          <Route path="/ai-lead-conversion" element={<AutomationsPage data-id="element-47" data-mp="3klydveajonh5" />} data-id="element-46" data-mp="3kob3mdmjo24r" />
          <Route path="/automations" element={<Navigate to="/ai-lead-conversion" replace data-id="element-49" data-mp="3gl65en9hymlx" />} data-id="element-48" data-mp="3gmpjc77oklkj" />
          <Route path="/custom-automations" element={<CustomAutomationsPage data-id="element-51" data-mp="205qw11vnkczh" />} data-id="element-50" data-mp="1w5gcsniunq2o" />
          <Route path="/crm-business-tools" element={<CrmBusinessToolsPage data-id="element-53" data-mp="254lf84xj83k4" />} data-id="element-52" data-mp="206jtfc8q1q4y" />
          <Route path="/reputation-management" element={<ReputationManagementPage data-id="element-55" data-mp="29wv7hrm4dfpk" />} data-id="element-54" data-mp="253sebkl9889w" />
          <Route path="/ad-campaigns" element={<AdCampaignsPage data-id="element-57" data-mp="2evppirc9j08m" />} data-id="element-56" data-mp="2euwsii33vp3o" />
          <Route path="/web-design-seo" element={<WebDesignSeoPage data-id="element-59" data-mp="2jtr8zddlp1km" />} data-id="element-58" data-mp="2eun0koyi37vc" />
          <Route path="/google-business-profile-setup" element={<GbpSetupPage data-id="element-61" data-mp="2nv339w7f6az5" />} data-id="element-60" data-mp="2jsybz44g1qfo" />
          <Route path="/tools/gmail-signature-generator" element={<GmailSignatureGeneratorPage data-id="element-63" data-mp="2stmr625kpwu5" />} data-id="element-62" data-mp="2nw4cdv4vkne8" />
          <Route path="/pricing" element={<PricingPage data-id="element-65" data-mp="tid8lc988xqp" />} data-id="element-64" data-mp="thlb1vw2kpxs" />
          <Route path="/about" element={<AboutPage data-id="element-67" data-mp="tjy1yyjt2amz" />} data-id="element-66" data-mp="tj4rbmhq70zk" />
          <Route path="/case-studies/tfp-landscaping" element={<TfpLandscapingPage data-id="element-69" data-mp="yihob02b9ofv" />} data-id="element-68" data-mp="yg4yk0qba9s9" />
          <Route path="/case-studies/finish-coat-painting" element={<FinishCoatPaintingPage data-id="element-71" data-mp="1wt0qdduseac0" />} data-id="element-70" data-mp="21slqhrlp0oqb" />
          <Route path="/case-studies" element={<CaseStudiesPage data-id="element-73" data-mp="2as0iwwlf79dg" />} data-id="element-72" data-mp="1wubuxfw23m46" />
          <Route path="/blog" element={<BlogPage data-id="element-75" data-mp="2atjzkoaznmfr" />} data-id="element-74" data-mp="2atbnuzqlqn65" />
          <Route path="/blog/how-to-choose-marketing-agency" element={<HowToChooseMarketingAgency data-id="element-77" data-mp="25v9zbzaepvna" />} data-id="element-76" data-mp="25t5pz1tqo4fm" />
          <Route path="/blog/why-response-time-makes-or-breaks-your-yelp-ads" element={<WhyResponseTimeMakesOrBreaksYourYelpAds data-id="element-79" data-mp="2fqaev9eyye04" />} data-id="element-78" data-mp="2kpelptef7zna" />
          <Route path="/blog/faster-yelp-replies-more-landscaping-estimates" element={<FasterYelpRepliesMoreLandscapingEstimates data-id="element-81" data-mp="2pheso5swrstd" />} data-id="element-80" data-mp="2tii84r71nmu2" />
          <Route path="/blog/ai-receptionist-vs-human-receptionist-cost" element={<AiReceptionistVsHumanReceptionistCost data-id="element-83" data-mp="33h7htwose0z8" />} data-id="element-82" data-mp="2pj9dlk46jkxg" />
          {/* Legacy /f/ blog URLs -- redirect old indexed links to the new in-app posts */}
          <Route path="/f/why-response-time-makes-or-breaks-your-yelp-ads" element={<Navigate to="/blog/why-response-time-makes-or-breaks-your-yelp-ads" replace data-id="element-85" data-mp="3n1enxi9l2hag" />} data-id="element-84" data-mp="3i3d610nw8o0k" />
          <Route path="/f/faster-yelp-replies-more-landscaping-estimates" element={<Navigate to="/blog/faster-yelp-replies-more-landscaping-estimates" replace data-id="element-87" data-mp="2zclmx7e3tj8z" />} data-id="element-86" data-mp="3d49yn9kfy5pf" />
          <Route path="/contact" element={<ContactPage data-id="element-89" data-mp="2pf7gm0lwaaue" />} data-id="element-88" data-mp="345ycbjqlxu2s" />
          <Route path="/privacy" element={<PrivacyPolicyPage data-id="element-91" data-mp="2pcust6tgh69f" />} data-id="element-90" data-mp="2pg0lsx57gsaf" />
          <Route path="/terms" element={<TermsOfServicePage data-id="element-93" data-mp="2uf3nq8pw2ie6" />} data-id="element-92" data-mp="2udsjk7sj78mj" />
        </Routes>
      </main>
      <Footer data-id="element-94" data-mp="2gej63fvpmsm9" />
    </div>;
}
export function App() {
  useEffect(() => {
    // Google Analytics (gtag.js)
    const GA_MEASUREMENT_ID = 'G-C4JZKB2BFQ';
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(gtagScript);
    const gtagInit = document.createElement('script');
    gtagInit.text = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_MEASUREMENT_ID}');
    `;
    document.head.appendChild(gtagInit);
    // Meta Pixel
    const fbScript = document.createElement('script');
    fbScript.text = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '970566142171718');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(fbScript);
    const fbNoscript = document.createElement('noscript');
    const fbImg = document.createElement('img');
    fbImg.height = 1;
    fbImg.width = 1;
    fbImg.style.display = 'none';
    fbImg.src = 'https://www.facebook.com/tr?id=970566142171718&ev=PageView&noscript=1';
    fbNoscript.appendChild(fbImg);
    document.body.appendChild(fbNoscript);
    // GHL Chat Widget
    const chatDiv = document.createElement('div');
    chatDiv.setAttribute('data-chat-widget', '');
    chatDiv.setAttribute('data-widget-id', '69ced0ba10e73a6e4e745753');
    chatDiv.setAttribute('data-location-id', 'JLycxFbUVQFY3z4zPpCS');
    document.body.appendChild(chatDiv);
    const script = document.createElement('script');
    script.src = 'https://widgets.leadconnectorhq.com/loader.js';
    script.setAttribute('data-resources-url', 'https://widgets.leadconnectorhq.com/chat-widget/loader.js');
    script.setAttribute('data-widget-id', '69ced0ba10e73a6e4e745753');
    document.body.appendChild(script);
    return () => {
      if (gtagScript.parentNode) gtagScript.parentNode.removeChild(gtagScript);
      if (gtagInit.parentNode) gtagInit.parentNode.removeChild(gtagInit);
      if (fbScript.parentNode) fbScript.parentNode.removeChild(fbScript);
      if (fbNoscript.parentNode) fbNoscript.parentNode.removeChild(fbNoscript);
      if (chatDiv.parentNode) chatDiv.parentNode.removeChild(chatDiv);
      if (script.parentNode) script.parentNode.removeChild(script);
    };
  }, []);
  return <BrowserRouter data-id="element-95" data-mp="26etgh6ks23uh">
      <ScrollToTop data-id="element-96" data-mp="26ejr9l7k40pu" />
      <Routes data-id="element-97" data-mp="26e1mu1aqqg6u">
        <Route path="/robots.txt" element={<RobotsTxt data-id="element-99" data-mp="2b5joysoi2mte" />} data-id="element-98" data-mp="26diftfmmpc7l" />
        <Route path="/sitemap.xml" element={<SitemapXml data-id="element-101" data-mp="2b733oeuicpt2" />} data-id="element-100" data-mp="2b5s1ukkmhs4l" />
        <Route path="/*" element={<SiteLayout data-id="element-103" data-mp="1dqnxopdaaoxa" />} data-id="element-102" data-mp="2b7cxyeml5j4k" />
      </Routes>
    </BrowserRouter>;
}